import React, { useEffect } from "react";
import styles from "./ConversationalAIComponent.module.scss";
import { Chat } from "companion-workspace";
import "companion-workspace/styles.css";
import "companion-workspace/theme-provider.css";
import authService from "../../config/auth.service";
import { useTranslation } from "react-i18next";
import { withUtag } from "../../utils/analytics";
import { useAppSelector } from "../../redux/hooks";
import { RootState } from "../../redux/store";

const ConversationalAIComponent: React.FC = () => {
  const { i18n } = useTranslation();

  const token = localStorage.getItem("auth-accessToken") || "";
  let loggedInUserFirstName = '';
  const decodedAccessToken: any = token && authService.decodeAccessToken(token);
  if (decodedAccessToken) {
    const loggedInUserfullName = decodedAccessToken["FullName"] || 'User';
    loggedInUserFirstName = loggedInUserfullName?.trim()?.split(' ')[0] || "";
  }

  const currentTheme = useAppSelector(
    (state: RootState) => state.theme.currentTheme
  );
  useEffect(() => {
    const viewUtagObject = {
      event_name: "amintelligence_view",
      am_country: localStorage?.getItem('userCountryCode') || '',
      am_affiliate: localStorage?.getItem('userAffiliateCode') || '',
      user_role: JSON.parse(localStorage.getItem("userRoleType") || "[]"),
      theme_toggle: currentTheme
    };

    withUtag().then((utag) => utag.view(viewUtagObject));
  }, []);

  const langCode = i18n.language?.split('-')[0];
  const pageLanguage: 'en' | 'th' = langCode === 'th' ? 'th' : 'en';

  return (
    <div
      className={styles.convers_AI_main_container}
    >
      {token && <Chat accessToken={`Bearer ${token}`} userFirstName={loggedInUserFirstName} pageLanguage={pageLanguage} />}
    </div>
  );
};

export default ConversationalAIComponent;